import React from 'react'
import { observer } from 'mobx-react'
import Select from './Select'
import AddButton from './AddButton'
import PortModal from './PortModal'

function PortSwitcher (props) {

  return (
    <div className={'port-switcher'}>
      <div className={'port-switcher__selector'}>
        <Select/>
        <AddButton/>
      </div>
      <PortModal/>
    </div>
  )
}

export default observer(PortSwitcher)
